// extracted by mini-css-extract-plugin
module.exports = {"container":"subcategory_container__Pa7Bu","removeThisClass":"subcategory_removeThisClass__2hZKM"};